import { type Timestamp, timestampDate } from '@bufbuild/protobuf/wkt'

import { formatJstDateTimeHm } from '~/models/dateTime'

/**
 * proto Timestamp を表示用の日時文字列（yyyy/MM/dd HH:mm、**JST 壁時計**）に変換する。
 *
 * 書式は一覧 (`ProcurementPlanList` 等) の `formatTimestamp` と同じ (Design Note
 * Decision 7)。
 *
 * @param ts - proto Timestamp（optional）
 * @param fallback - ts が undefined のときの表示文字列（デフォルト "—"）
 */
export function formatTimestamp(
  ts: Timestamp | undefined,
  fallback = '—',
): string {
  if (!ts) return fallback
  return formatJstDateTimeHm(timestampDate(ts))
}
